import { useCapabilitiesOptional } from "@/providers/CapabilitiesProvider";
import { useEventContextOptional } from "@/providers/EventProvider";
import { Plugin } from "@/types/enums/Plugin";
import { smsChannelEnabledOf, withoutUnofferedSmsFields } from "./smsCapabilities";

/**
 * Are the SMS guest fields (`smsOptIn`, `smsOptInAt`, `smsOptInSource`)
 * OFFERED FOR ADDING here? (SMS plugin wave, F-6 / Q3.)
 *
 * Stricter than "the fields exist": the platform switch on AND the event's SMS
 * plugin on, read from the event shell's own event — no fetch. Not known is
 * "no": outside an EventProvider, or while the shell still paints the
 * PREVIOUS event as a placeholder (`eventIsPlaceholder`), nothing is offered.
 *
 * Only the four offer surfaces read this (the column picker's AVAILABLE list,
 * a new filter row's field picker, the guest-import mapper, the "export
 * everything" default). Everything that shows what is already there — saved
 * views and filters, layout and detail cells, role allowlists, conditions —
 * stays on the platform switch alone (`FieldsProvider`), so switching the
 * plugin off never hides data the user already saved.
 */
export function smsFieldsOfferedOf(
  caps: unknown,
  ctx: { event?: { plugins?: unknown } | null; eventIsPlaceholder?: boolean } | null | undefined,
): boolean {
  if (!smsChannelEnabledOf(caps)) return false;
  if (!ctx || ctx.eventIsPlaceholder === true) return false;
  const plugins = ctx.event?.plugins;
  return Array.isArray(plugins) && plugins.includes(Plugin.SMS);
}

export function useSmsFieldsOffered(): boolean {
  return smsFieldsOfferedOf(useCapabilitiesOptional(), useEventContextOptional());
}

/** Re-exported for the offer surfaces; lives with the field names (no providers). */
export { withoutUnofferedSmsFields };
